import ComponentMatrixProvider from './component-matrix.provider'

const module = angular.module('ac.providers', [])

module.factory('ComponentMatrixProvider', ComponentMatrixProvider)

export default module.name
